<template>
  <div class="multiselect">
    <MultiselectCheckbox
      v-for="(option, index) in options"
      :key="index"
      :val="index"
      v-model="ordersState"
    >
      <span v-html="$t('depotfinder.orders.options.'+index)"></span>
    </MultiselectCheckbox>
  </div>
</template>

<script>
import MultiselectCheckbox from "./MultiselectCheckbox.vue";

export default {
  components: {
    MultiselectCheckbox
  },
  data() {
    return {
      options: this.$t("depotfinder.orders.options")
    };
  },

  computed: {
    ordersState: {
      get() {
        return this.$store.getters.getOrdersState;
      },
      set(value) {
        this.$store.dispatch("updateOrdersState", value);
      }
    }
  }
};
</script>
